/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Data payload for \'email.failed\' notifications.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface EmailFailedData { 
    appointmentId: number;
    error: string;
}
export const EmailFailedData_appointmentId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const EmailFailedData_error_Validators: ValidatorFn[] =
    [  Validators.required, ];


